import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import typeOperationLogScore from "./typeOperationLogScore";
import Pagination from "../../../partials/content/Pagination";

export default function AllLogScorePublisher() {
  const [allLogScorePublisher, setAllLogScorePublisher] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [logScorePublisherID, setLogScorePublisherID] = useState(0);

  useEffect(() => {
    getAllLogScorePublisher();
  }, [currentPage, logScorePublisherID]);

  const getAllLogScorePublisher = async () => {
    const userID = parseInt(document.querySelector("#user-id").value);
    if (!userID) {
      return;
    }
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allScoreLogPosition = await sendRequestGetAllLogScorePublisher(
      userID,
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allScoreLogPosition) {
      return;
    }

    setAllLogScorePublisher(allScoreLogPosition.logs_publishers_score);
    setCountPage(allScoreLogPosition.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (logScorePublisherID) {
      searchFilterQuery = `${searchFilterQuery}&id=${logScorePublisherID}`;
    }

    return searchFilterQuery;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestGetAllLogScorePublisher = async (
    userPublisherID,
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequest();
    let allLogWalletPublisher;
    try {
      allLogWalletPublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/finance/log-score/publisher/${userPublisherID}/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allLogWalletPublisher.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateAllLogScorePublisher = () => {
    return (
      <>
        <div className="alert alert-info mt-2">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setLogScorePublisherID(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="pb-4 px-2">
          <div className="table-responsive pt-2">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره لاگ </td>
                  <td>مبلغ قبل از اعمال</td>
                  <td>مبلغ بعد از اعمال</td>
                  <td>مبلغ اعمال شده</td>
                  <td> نوع تراکنش </td>
                  <td>نوع عملیات </td>
                  <td>شماره ارجاع</td>
                  <td>تاربخ درج</td>
                </tr>
              </thead>
              <tbody>
                {allLogScorePublisher.map((item, index) => {
                  return (
                    <tr>
                      <td>{helperNumbers.toPersianNum(index + 1)}</td>
                      <td>{helperNumbers.toPersianNum(item.pls_id)}</td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            item.pls_score_before
                          )
                        )}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            item.pls_score_after
                          )
                        )}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(item.pls_amount)
                        )}
                      </td>
                      <td>
                        {item.pls_type_operation ? (
                          <span className="badge badge-success">افزایش</span>
                        ) : (
                          <span className="badge badge-warning">کاهش </span>
                        )}
                      </td>
                      <td>
                        {
                          typeOperationLogScore.getTypeOperationString()[
                            item.pls_type_payment
                          ]
                        }
                      </td>
                      <td>{item.pls_ref_id}</td>
                      <td>
                        {helperNumbers.toPersianNum(
                          item.pls_created_at.split(" ")[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              item.pls_created_at.split(" ")[0]
                            )
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
      </>
    );
  };

  const generateUserPublisherDoseNotHaveAnyLogScorePublisher = () => {
    return (
      <div className="alert alert-info">
        این کاربر هیچ گزارش تغییرات موجودی کاربر نمایش دهنده ندارد
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-log-score-publisher" />

      <div className="content-wrapper">
        <TitleBar title="گزارش تغییرات Hicoin کاربر نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAllLogScorePublisher();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="number"
                      id="user-id"
                      class="form-control"
                      placeholder="شماره کاربر نمایش دهنده را وارد کنید."
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                {allLogScorePublisher.length == 0 && logScorePublisherID == 0
                  ? generateUserPublisherDoseNotHaveAnyLogScorePublisher()
                  : generateAllLogScorePublisher()}

                {/* {allLogScorePublisher.length > 0
                  ? generateAllLogScorePublisher()
                  : generateUserPublisherDoseNotHaveAnyLogScorePublisher()} */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
